/** RSI cell colors, labels, and watchlist formatting (stock thresholds). */

import { rsiCellTooltip } from "./signalTooltips.js";

const RSI_OVERSOLD_BRIGHT = "#ff5555";

export function getRsiDisplayMeta(rsi) {
  if (rsi == null || Number.isNaN(rsi)) return { label: "—", zone: "none" };
  if (rsi > 70) return { label: "Strong momentum", zone: "momentum" };
  if (rsi >= 50) return { label: "Bullish", zone: "bullish" };
  if (rsi >= 45) return { label: "Neutral", zone: "neutral" };
  if (rsi >= 30) return { label: "Weakening", zone: "weakening" };
  return { label: "Oversold", zone: "oversold" };
}

/** @param {Record<string, string>} T theme tokens */
export function rsiDisplayColor(rsi, T) {
  const { zone } = getRsiDisplayMeta(rsi);
  switch (zone) {
    case "momentum":
      return T.yellow;
    case "bullish":
      return T.green;
    case "neutral":
      return T.text;
    case "weakening":
      return T.red;
    case "oversold":
      return RSI_OVERSOLD_BRIGHT;
    default:
      return T.textSub;
  }
}

export function formatRsiWithDivergence(rsi, rsiDiv, decimals = 0) {
  if (rsi == null) return "—";
  const base = decimals === 0 ? String(Math.round(rsi)) : rsi.toFixed(decimals);
  if (rsiDiv?.bullish) return `${base} ↑`;
  if (rsiDiv?.bearish) return `${base} ↓`;
  return base;
}

export function rsiDisplayTooltip(rsi, rsiDiv) {
  return rsiCellTooltip(rsi, rsiDiv);
}

export const RSI_COLUMN_HEADER_TIP =
  "RSI (14) — >70 strong momentum, 50–70 bullish zone, <50 caution. ↑/↓ = context-aware divergence only (filters breakouts and new structure).";

/** Subline under RSI when raw pattern exists but context filters blocked divergence. */
export function rsiWatchlistSubline(result) {
  if (!result?.rsiDivergenceContext) return null;
  if (result.rsiDiv?.bullish || result.rsiDiv?.bearish) return null;
  const ctx = result.rsiDivergenceContext;
  if (/ignored — confirmed Donchian breakout/i.test(ctx)) return "no div · breakout";
  if (/ignored — price just reclaimed EMA/i.test(ctx)) return "no div · new structure";
  if (/ignored — score jumped/i.test(ctx)) return "no div · momentum";
  if (/not extended enough/i.test(ctx)) return "div watch";
  return null;
}

export function rsiCellTooltipExtended(rsi, result) {
  const base = rsiCellTooltip(rsi, result?.rsiDiv);
  const ctx = result?.rsiDivergenceContext;
  if (!ctx || result?.rsiDiv?.bullish || result?.rsiDiv?.bearish) return base;
  if (/ignored|not extended/i.test(ctx)) {
    return base ? `${base}\n\n${ctx}` : ctx;
  }
  return base;
}
